import { css } from '@emotion/react'

import { borderRadius, size } from '@twisto/styles'

export const successBox = css`
  margin: ${size[24]};
  border-radius: ${borderRadius.md};
`

export const buttonSection = css`
  display: grid;
  grid-gap: ${size[16]};
  padding: 0 ${size[48]} ${size[64]};
`
